import type { MarketplaceCode } from "./types";

const SELLER_CENTRAL_DOMAINS: Record<MarketplaceCode, string> = {
  DE: "sellercentral.amazon.de",
  IT: "sellercentral.amazon.it",
  FR: "sellercentral.amazon.fr",
  BE: "sellercentral.amazon.com.be",
  NL: "sellercentral.amazon.nl",
  IE: "sellercentral.amazon.ie",
};

export function sellerCentralRootUrl(marketplace: MarketplaceCode): string {
  return `https://${SELLER_CENTRAL_DOMAINS[marketplace]}/`;
}

export function sellerCentralInventoryUrl(
  marketplace: MarketplaceCode,
  item: { asin?: string | null; sellerSku?: string | null },
): string {
  const searchTerm = String(item.asin || item.sellerSku || "").trim();
  if (!searchTerm) return sellerCentralRootUrl(marketplace);
  return (
    `https://${SELLER_CENTRAL_DOMAINS[marketplace]}/myinventory/inventory` +
    `?fulfilledBy=all&page=1&pageSize=25&searchField=all` +
    `&searchTerm=${encodeURIComponent(searchTerm)}` +
    "&sort=date_created_desc&status=all"
  );
}

export function sellerCentralAccountHealthUrl(
  marketplace: MarketplaceCode = "DE",
): string {
  return `https://${SELLER_CENTRAL_DOMAINS[marketplace]}/performance/dashboard`;
}
